import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './core/guards/auth.guard';
import { PlatformGuard } from './core/guards/platform.guard';
import { MainLayoutComponent } from './shared/components/main-layout/main-layout.component';
import { UnauthorizedComponent } from './pages/unauthorized/unauthorized.component';

export const routes: Routes = [
  // Public auth routes
  {
    path: 'federation/auth',
    loadChildren: () =>
      import('./pages/auth/auth.module').then((m) => m.AuthModule),
  },

  // Protected routes — wrapped in MainLayoutComponent. Two zones, each with its own guard:
  // /plateforme/** works without a chosen federation (PlatformGuard), /federation/** needs one (AuthGuard).
  {
    path: '',
    component: MainLayoutComponent,
    runGuardsAndResolvers: 'always',
    children: [
      {
        path: 'plateforme/federations',
        canActivate: [PlatformGuard],
        runGuardsAndResolvers: 'always',
        loadChildren: () =>
          import('./pages/platform/platform.module').then((m) => m.PlatformModule),
      },
      {
        // /plateforme/comptes + /plateforme/roles (Digi4 team, SIQ-145)
        path: 'plateforme',
        canActivate: [PlatformGuard],
        runGuardsAndResolvers: 'always',
        loadChildren: () =>
          import('./pages/platform/team/team.module').then((m) => m.TeamModule),
      },
      {
        path: 'federation',
        canActivate: [AuthGuard],
        runGuardsAndResolvers: 'always',
        loadChildren: () =>
          import('./pages/federation/federation.module').then((m) => m.FederationModule),
      },
      { path: '', redirectTo: 'federation/dashboard', pathMatch: 'full' },
    ],
  },

  // Error pages
  { path: 'unauthorized', component: UnauthorizedComponent },
  { path: 'no-access', component: UnauthorizedComponent },

  { path: '**', redirectTo: 'federation/auth/login' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload' })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
